<template>
    <div class="firstList" ref="prizeList">
        <img class="bgImg" :src="bgImg" alt="">
        <div class="list">
            <ul class="content-list">
                <li v-for="(item, index) in winnerList" :key="index">
                    <p class="name">
                        <span class="tel">{{item.user_code}}</span>
                        {{item.user_name}}
                    </p>
                    <p class="address">{{item.school}}</p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "WinnerList",
        props: {
            stage: {
                type: String,
                default: 'first'
            }, // 阶段
            winnerList: {
                type: Array,
                default: function () {
                    // return [{user_name: '张三风味',user_code: '18811702331', school: '北京市朝阳北京市朝阳北京市朝阳北京市朝阳'}, {user_name: '张三风味',user_code: '18811702331', school: '北京市朝阳区'}, {user_name: '张三风味',user_code: '18811702331', school: '北京市朝阳区'}, {user_name: '张三',user_code: '18811702331', school: '北京市朝阳区'}, {user_name: '张三',user_code: '18811702331', school: '北京市朝阳区'}]
                    return []
                }
            }, // 获奖名单
            imgPosition: {
                type: String,
                default: 'top'
            } // 图片位置
        },
        data () {
            return {
                baseUrl: process.env.BASE_URL
            }
        },
        computed: {
            bgImg() {
                // if (this.stage === 'second') {
                //     if (this.imgPosition === 'top') {
                //         return this.baseUrl + 'images/second-top-list.png'
                //     } else {
                //         return this.baseUrl + 'images/first-list.png'
                //     }
                // } else {
                //     return this.baseUrl + 'images/first-list.png'
                // }
                if (this.stage === 'second') {
                    if (this.imgPosition === 'top') {
                        return 'http://source.weicistudy.com/draw/public/second-top-list.png'
                    } else {
                        return 'http://source.weicistudy.com/draw/public/first-list.png'
                    }
                } else {
                    return 'http://source.weicistudy.com/draw/public/first-list.png'
                }
            } // 根据条件引入不同图片
        },
        mounted () {
            if (this.imgPosition === 'bottom') {
                this.$refs.prizeList.style.marginTop = '-20px';
            } else {
                this.$refs.prizeList.style.zIndex = '1'
            }
        }
    }
</script>

<style scoped>
    .firstList {
        position: relative;
    }
    .firstList .bgImg {
        width: 100%;
    }
    .list {
        position: absolute;
        top:161px;
        /*left:190px;*/
        /*width:368px;*/
        width: 100vw;
        height: 600px;
    }
    .content-list {
        position: absolute;
        top:50%;
        transform: translateY(-50%);
        width: 100%;
        text-align: center;
    }
    .list .name {
        display: inline-block;
        width: 368px;
        background:rgba(228,93,86,1);
        border-radius:27px;
        height:54px;
        line-height: 54px;
        text-align: center;
        font-size:28px;
        font-weight:400;
        color:rgba(255,237,236,1);
    }
    .name .tel {
        margin-right: 14px;
    }
    .address {
        font-size:24px;
        font-weight:400;
        color:rgba(46,46,46,1);
        margin: 12px 0 30px;
        width: 100%;
        text-align: center;
    }
</style>